import React, {Component} from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { updateFlyerTooHigh } from '../../../actions';
import toJS from '../../../hoc/toJS';


const mapDispatchToProps = (dispatch, ownProps) => ({
    onUpdateFlyerToHigh: tooHigh => {
        dispatch(updateFlyerTooHigh(ownProps.side, ownProps.section, tooHigh))
    }
})

class FlyerHeightContainer extends Component {
    constructor(props) {
        super(props)

        this.currentHeightRef = React.createRef();
        this.maxHeightRef = React.createRef();
        this.onChangeHeight = this.onChangeHeight.bind(this)
    }

    onChangeHeight() {
        const { flyerData, side, section, onUpdateFlyerToHigh } = this.props
        const currentHeight = this.currentHeightRef.current.clientHeight
        const maxHeight = this.maxHeightRef.current.clientHeight + 10
        const tooHigh = currentHeight > maxHeight
        const flyerSectionStructure = flyerData.flyerStructure[side][section]

        if(flyerSectionStructure.hasOwnProperty('tooHigh')) {
            if(flyerSectionStructure.tooHigh != tooHigh) {
                onUpdateFlyerToHigh(tooHigh)
            }
        } else {
            onUpdateFlyerToHigh(tooHigh)
        }
    }

    componentDidMount() {
        this.onChangeHeight()
    }

    componentDidUpdate() {
        this.onChangeHeight()
    }

    render() {
        const { children } = this.props
        const childElements = React.Children.map(children, child =>
            React.cloneElement(child, { 
                currentHeightRef: this.currentHeightRef,
                maxHeightRef: this.maxHeightRef,
                onLoadImg: this.onChangeHeight
            })
        )

        return childElements
    }
}

export default compose(
    connect(null, mapDispatchToProps),
    toJS(),
)(FlyerHeightContainer)

